import thunk from 'redux-thunk';
import { applyMiddleware, compose, createStore } from 'redux';
// import { asyncSessionStorage } from 'redux-persist/storages';
// import { autoRehydrate, persistStore } from 'redux-persist';

// import sagApi from '../middleware/sagApi';
import createLoggerMiddleware from '../middleware/logger';
import rootReducer from '../reducers';
// import { isSessionSaved, deleteAuthCookie, dumpAuthCookie } from '../core/cookie';


export default function configureStore(initialState, helpersConfig) {
  const middleware = [thunk];

  let enhancer;

  if (__DEV__) {
    middleware.push(createLoggerMiddleware());

    // https://github.com/zalmoxisus/redux-devtools-extension#redux-devtools-extension
    let devToolsExtension = f => f;
    if (process.env.BROWSER && window.devToolsExtension) {
      devToolsExtension = window.devToolsExtension();
    }

    enhancer = compose(
      applyMiddleware(...middleware),
      devToolsExtension,
    );
  } else {
    enhancer = compose(applyMiddleware(...middleware));
  }

  // See https://github.com/rackt/redux/releases/tag/v3.1.0
  const store = createStore(rootReducer, initialState, enhancer);


  // if (process.env.BROWSER && location.pathname !== '/widget') {
  //   persistStore(store, { storage: asyncSessionStorage });
  // }

  // Hot reload reducers (requires Webpack or Browserify HMR to be enabled)
  if (__DEV__ && module.hot) {
    module.hot.accept('../reducers', () => store.replaceReducer(require('../reducers').default));
  }

  return store;
}



// WEBPACK FOOTER //
// ./src/store/configureStore.js